import React from "react";
import Header from "../../Components/layouts/Header";

const Calculator = () => {
  return (
    <>
    <Header title="Crop Advisary" subtitle="Calculator" />
    <section className="p-5">
      <div className="grid grid-cols-[30%_30%_30%_10%]">
        <div className="font-extrabold grid grid-cols-[30%_50%_20%] items-center">
          <label className="text-[#13490A] text-center">Type</label>
          <input
            type="text"
            className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
          />
          <img src="Images/Dropdown.png" className="px-4" />
        </div>
        <div className="font-extrabold grid grid-cols-[30%_50%_20%] items-center">
          <label className="text-[#13490A] text-center">Crop</label>
          <input
            type="text"
            className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
          />
          <img src="Images/Dropdown.png" className="px-4" />
        </div>
        <div className="font-extrabold grid grid-cols-[30%_50%_20%] items-center">
          <label className="text-[#13490A] text-center">Variety</label>
          <input
            type="text"
            className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
          />
          <img src="Images/Dropdown.png" className="px-4" />
        </div>
        <button className="bg-[#05AB2A] text-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] font-light rounded-md h-8">
          Go
        </button>
      </div>
      <div className="grid grid-cols-[12%_12%_12%_12%_12%] gap-[6%] mx-[10%] mt-6 mb-9">
        <button className="bg-[#526D4E] text-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] font-light rounded-md h-8">
          Fertilizer
        </button>
        <button className="bg-[#05AB2A] text-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] font-light rounded-md h-8">
          Pesticide
        </button>
        <button className="bg-[#05AB2A] text-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] font-light rounded-md h-8">
          Herbicide
        </button>
        <button className="bg-[#05AB2A] text-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] font-light rounded-md h-8">
          Fungicide
        </button>
        <button className="bg-[#05AB2A] text-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] font-light rounded-md h-8">
          Yield
        </button>
      </div>
      <div className="font-extrabold grid grid-cols-[15%_30%_5%_15%] gap-[2%] mx-[20%] mb-[3%] items-center">
        <label className="text-center">Area</label>
        <input
          type="text"
          className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
        />
        <img src="Images/Dropdown.png" alt="Dropdown" className="" />
        <button className="bg-[#05AB2A] text-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] font-light rounded-md h-8">
          Calculate
        </button>
      </div>
      <table className="table-auto border-collapse border border-black font-bold text-base w-[80%] mx-auto">
        <thead className="border-b border-black">
          <tr className="text-center">
            <th className="border-r border-black py-[1.2%]">S.No</th>
            <th className="border-r border-black py-[1.2%]">Crop Stage</th>
            <th className="border-r border-black py-[1.2%]">Nutrients</th>
            <th className="border-r border-black py-[1.2%]">Quantity</th>
            <th className="border-r border-black py-[1.2%]">Products</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b border-black text-center">
            <td className="border-r border-black py-[1.2%]">01</td>
            <td className="border-r border-black py-[1.2%]">Prior to Sowing</td>
            <td className="border-r border-black py-[1.2%]">
              Farm Yard Manure(FYM)
            </td>
            <td className="border-r border-black py-[1.2%]">1 t/ha</td>
            <th className="border-r border-black py-[1.2%]">FYM</th>
          </tr>
          <tr className="border-b border-black text-center">
            <td className="border-r border-black py-[1.2%]">02</td>
            <td className="border-r border-black py-[1.2%]">
              Basal(at Sowing)
            </td>
            <td className="border-r border-black py-[1.2%]">Nitrogen</td>
            <td className="border-r border-black py-[1.2%]"></td>
            <th className="border-r border-black py-[1.2%]"></th>
          </tr>
          <tr className="border-b border-black text-center">
            <td className="border-r border-black py-[1.2%]">03</td>
            <td className="border-r border-black py-[1.2%]">
              V4(four leaf stage)
            </td>
            <td className="border-r border-black py-[1.2%]">Nitrogen</td>
            <td className="border-r border-black py-[1.2%]">1 t/ha</td>
            <th className="border-r border-black py-[1.2%]">FYM</th>
          </tr>
          <tr className="border-b border-black text-center">
            <td className="border-r border-black py-[1.2%]">04</td>
            <td className="border-r border-black py-[1.2%]">
              V8(eight leaf stage)
            </td>
            <td className="border-r border-black py-[1.2%]">Nitrogen</td>
            <td className="border-r border-black py-[1.2%]">1 t/ha</td>
            <th className="border-r border-black py-[1.2%]">FYM</th>
          </tr>
          <tr className="border-b border-black text-center">
            <td className="border-r border-black py-[1.2%]">05</td>
            <td className="border-r border-black py-[1.2%]">
              VT(tasseling stage)
            </td>
            <td className="border-r border-black py-[1.2%]">Nitrogen</td>
            <td className="border-r border-black py-[1.2%]">1 t/ha</td>
            <th className="border-r border-black py-[1.2%]">FYM</th>
          </tr>
          <tr className="border-b border-black text-center">
            <td className="border-r border-black py-[1.2%]">06</td>
            <td className="border-r border-black py-[1.2%]">
              GF(grain filling stage)
            </td>
            <td className="border-r border-black py-[1.2%]">Nitrogen</td>
            <td className="border-r border-black py-[1.2%]">1 t/ha</td>
            <th className="border-r border-black py-[1.2%]">FYM</th>
          </tr>
        </tbody>
      </table>
    </section>
    </>
  );
};

export default Calculator;
